







































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import WarehouseRemainForm from './WarehouseRemainForm/WarehouseRemainForm.vue'

import TitleBar from '@/components/Elements/TitleBar.vue'
import moment from 'moment'
import XLSX from 'xlsx';

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapGetters(STORE_KEY, [
      'total',
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'meta', 'days',

      'filter',

      'documents', 'lastMeta',

      'semiDocuments', 'semiLoading', 'semiLoaded'
    ]),
  },
  components: {
    TitleBar,
  }
})
export default class WarehousesInternalList extends Vue {
  public warehouse_id: any = null;
  public targetDate: any = null;
  public actor!: any;
  public visibleQuantity: boolean = false;

  public activeTab: number = 0;

  documents!: any[];
  semiDocuments!: any[];
  semiLoading!: boolean;
  semiLoaded!: boolean;

  get currentTabData(): any[] {
    return this.activeTab === 1 ? this.semiDocuments : this.documents;
  }

  onTabChange(tab: number) {
    if (tab === 1 && !this.semiLoaded) {
      this.$store.dispatch(`${STORE_KEY}/loadSemiData`);
    }
  }

  get titleStack () {
    return [
      'Склады полупродукта'
    ]
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'quantity', this.$route.query.sortDirection || 'asc']
  }

  get today() {
    return moment().format('DD.MM.YYYY')
  }

  get selectedView() {
    return this.$route.query.view || 'day'
  }

  setParams(filterName: string, filterValue: any) {
    console.log(filterName, filterValue)
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      },
    })
  }

  unselectableDates(day: any) {
    return moment().date() > moment(day).date()
  }

  confirmDeleteTransportCosts(row: any) {
    this.$buefy.dialog.confirm({
      message: `Удалить запись на сумму ${row.costs} руб. (клиент: ${row.client_name}, зона: ${row.delivery_zone_name})`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/deleteTransportCost`, {
          id: row.id
        })
        .then((result) => {
          this.$buefy.snackbar.open(`Запись удалена`);
          this.handleParamsChange();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: 'is-warning',
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          })
        })
      }
    })
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }
  private delayFilter: any = null

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...filter
          }
        })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
  }

  onTargetDateChange(targetDate: string) {
    console.log('onTargetDateChange', targetDate)
    this.$router.replace({
      query: { ...this.$route.query, targetDate: moment(targetDate).format('YYYY-MM-DD') }
    })
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  onWarehouseChange(warehouse_id: string) {
    console.log('onWarehouseChange', warehouse_id)
    this.$router.replace({
      query: { ...this.$route.query, warehouse_id }
    })
  }

  openWarehousesRemainForm(warehouse_id: any, fileForm: boolean) {
    const manager_id = this.actor.document.id
    this.$buefy.modal.open({
      component: WarehouseRemainForm,
      props: {
        isNew: true,
        fileForm: fileForm,
        initParams: {
          warehouse_id,
          manager_id
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  tableToExcel() {
    const csvContent: any[] = [];

    if (this.activeTab === 1) {
      csvContent.push(...this.$store.getters[`${STORE_KEY}/exportSemiData`]);
      const ws = XLSX.utils.aoa_to_sheet(csvContent);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Отчет");
      XLSX.writeFile(wb, 'semi-products.xlsx')
      return;
    }

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws['!ref']);
    for(let R = range.s.r; R <= range.e.r; ++R) {

      for(let C = range.s.c; C <= range.e.c; ++C) {
        const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
        if(!ws[cellref] || C < 2 || R < 1) continue; // if cell doesn't exist, move on
        const cell = ws[cellref];
        cell.t = 'n'
        cell.z = '0.00'
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, 'export.xlsx')
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    if (this.$route.query.targetDate) {
      // @ts-ignore
      this.targetDate = moment(this.$route.query.targetDate).toDate()
    }else {
      this.targetDate = moment().add(1, 'day').toDate()
    }
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
